/**
 * Lazy embeds (click-to-load) for heavy iframes (YouTube/Vimeo/etc).
 * Usage: add `data-lazy-embed` and `data-src` to a wrapper element.
 *
 * Example:
 *   <div class="video-wrapper" data-lazy-embed data-src="https://www.youtube.com/embed/ID?...">
 *     <button type="button" class="lazy-embed__overlay" aria-label="Play video">...</button>
 *     <noscript>...</noscript>
 *   </div>
 */
(function () {
  'use strict';

  function buildIframe(src) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('title', 'Video');
    return iframe;
  }

  function loadEmbed(wrapper) {
    if (!wrapper || wrapper.dataset.embedLoaded === 'true') return;
    var src = wrapper.dataset.src;
    if (!src) return;

    wrapper.dataset.embedLoaded = 'true';
    wrapper.classList.add('is-embed-loaded');

    // Clear everything except <noscript> (if present), then inject iframe.
    var nodes = Array.prototype.slice.call(wrapper.childNodes);
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'NOSCRIPT') return;
      wrapper.removeChild(n);
    });

    wrapper.appendChild(buildIframe(src));
  }

  function enhanceWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.lazyEmbedsInit === 'true') return;
    wrapper.dataset.lazyEmbedsInit = 'true';

    wrapper.addEventListener('click', function (evt) {
      // Click anywhere on the overlay/wrapper should load the video.
      var overlay = evt.target && evt.target.closest ? evt.target.closest('.lazy-embed__overlay') : null;
      if (overlay || wrapper.contains(evt.target)) {
        loadEmbed(wrapper);
      }
    });

    wrapper.addEventListener('keydown', function (evt) {
      // Space/Enter to activate if overlay focused.
      var key = evt.key || evt.keyCode;
      if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
        var active = document.activeElement;
        if (active && active.classList && active.classList.contains('lazy-embed__overlay')) {
          evt.preventDefault();
          loadEmbed(wrapper);
        }
      }
    });
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-lazy-embed][data-src]');
    if (!wrappers || !wrappers.length) return;
    Array.prototype.forEach.call(wrappers, enhanceWrapper);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:loaded', init);
})();

